import { useEffect, useState } from 'react'
import axios from 'config/axios'
import { RootState } from 'state'
import { useSelector } from 'react-redux'

const useGiveawayDetail = (id: string | null, update?: boolean) => {
  const [data, setData] = useState<any>({
    giveaway: {},
    send_datas: [],
    wait_datas: [],
  })
  const [loading, setLoading] = useState(false)
  const space_update = useSelector((state: RootState) => state.space.space_code)
  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await axios.get(`/api/admin/giveaway/token/${id}/detail`)
      setLoading(false)
      if (res.data.code === 0) {
        setData(res?.data?.data)
      }
    } catch (error) {
      console.error('useGiveawayDetail --> ' + error)
    }
  }
  useEffect(() => {
    if (id) fetchData()
    // eslint-disable-next-line
  }, [id, space_update, update])
  return [data, loading]
}

export default useGiveawayDetail
